/* eslint-disable max-len */
import React, { useState } from 'react';
import { Label, Flex, Text, FileInput, Pane, Button } from '@leverege/ui-elements';
import classes from './ImageUploader.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ACCEPTED_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp'];
function getBytesSize(size) {
  let sizeResult, unit;
  if (size > 1000 * 1000) {
    sizeResult = Math.round(size / (1000 * 1000) * 100) / 100;
    unit = 'MB';
  } else if (size > 1000) {
    sizeResult = Math.round(size / 1000 * 100) / 100;
    unit = 'KB';
  } else {
    sizeResult = size;
    unit = 'bytes';
  }
  return `${sizeResult} ${unit}`;
}

/**
 * Uploader.
 */
export default function ImageUploader(props) {
  const {
    value,
    eventData,
    label,
    onChange
  } = props;
  const [url, setUrl] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const onSelect = event => {
    const {
      onChange,
      eventData
    } = props;
    const file = event?.value[0];
    const fileUrl = URL.createObjectURL(file);
    const size = file.size;
    if (size > 2000000) {
      setErrorMessage('File size exceeds 2 MB. Please try again.');
      return;
      // eslint-disable-next-line no-else-return
    } else if (!ACCEPTED_EXTENSIONS.some(val => file.name.endsWith(val))) {
      setErrorMessage('File type is not in a supported format.');
      return;
    }
    setUrl(fileUrl);
    setErrorMessage(null);
    onChange({
      data: eventData,
      value: file
    });
  };
  const onDelete = () => {
    setErrorMessage(null);
    onChange({
      data: eventData,
      value: null
    });
  };
  if (value) {
    return /*#__PURE__*/_jsxs(Pane, {
      layout: "flex:colS",
      children: [/*#__PURE__*/_jsx(Label, {
        variant: "inputTitle",
        children: label
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "rowM",
        align: "flex-start",
        children: [/*#__PURE__*/_jsx("img", {
          src: url,
          alt: "",
          className: classes.image
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colM",
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "captionSmallBold",
            className: classes.title,
            children: value?.name
          }), /*#__PURE__*/_jsx(Label, {
            variant: "captionSmall",
            children: value instanceof File && getBytesSize(value?.size)
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "colM",
            children: [/*#__PURE__*/_jsx(FileInput, {
              variant: "secondarySmallLeftIcon",
              eventData: eventData,
              fileTypes: ACCEPTED_EXTENSIONS,
              onChange: onSelect,
              children: "Replace Image"
            }), /*#__PURE__*/_jsx(Button, {
              variant: "dangerSmallLeftIcon",
              onClick: onDelete,
              children: " Delete "
            })]
          })]
        })]
      }), errorMessage ? /*#__PURE__*/_jsx(Text, {
        variant: "inputCaptionSmallError",
        children: errorMessage
      }) : null]
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "colS",
    children: [/*#__PURE__*/_jsx(Label, {
      variant: "inputTitle",
      children: label
    }), /*#__PURE__*/_jsx(Flex, {
      variant: "rowS",
      align: "center",
      children: /*#__PURE__*/_jsx(FileInput, {
        variant: "uploadFile",
        eventData: eventData,
        fileTypes: ACCEPTED_EXTENSIONS,
        onChange: onSelect,
        children: "Add Image"
      })
    }), /*#__PURE__*/_jsx(Label, {
      variant: "helperText",
      children: "Supported file types: .jpg, .jpeg, .png, .webp. Max file size: 2MB"
    }), errorMessage ? /*#__PURE__*/_jsx(Text, {
      variant: "inputCaptionSmallError",
      children: errorMessage
    }) : null]
  });
}